// extracted by mini-css-extract-plugin
module.exports = {"UpgradeWrapper":"sustainability_UpgradeWrapper__DX4mR"};